import React from "react";

const AboutAuth = () => {
  return (
    <div className="authContainer-1">
      <h1>Join the Stack Overflow comunity</h1>
      <p>Get unstuck — ask a question</p>
      <p>Unlock new privileges like voting and commenting</p>
      <p>Save your favorite tags, filters, and jobs</p>
      <p>Earn reputation and badges</p>
      <p style={{fontSize: "13px" }}>
        Collaborate and share knowledge with a private group for FREE.
      </p>
      <p style={{ color: "#007ac6", fontSize: "13px" }}>
        Get Stack Overflow for Teams free for up to 50 users.
      </p>
    </div>
  );
};

export default AboutAuth;
